import React from "react";
import { Typography } from "@mui/material";
import TitleDefinition from "components/TitleDefinition";

interface RequiredLabelV2Props {
  labelText: string;
  isHelperTextRequired?: boolean;
  content?: string;
}

const RequiredLabelV2: React.FC<RequiredLabelV2Props> = ({ labelText, isHelperTextRequired = false, content = "" }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
    <span style={{ display: "flex", alignItems: "center", fontWeight: 600, fontSize: 12, fontFamily: 'inherit' }} data-testid={`${labelText.replace(/\s+/g, "").toLowerCase()}Label`}>
      {labelText}
      <Typography component="span" sx={{ color: "red" }}>
              *
            </Typography>
      
    </span>
    {content && (
      <TitleDefinition content={content} placement="top" />
    )}
  </div>
);

export default RequiredLabelV2;
